export default {
  title: 'Kvitteringsudskrivning',
  sections: {
    destination: 'Kvitteringer udskrives på',
  },
  printers: {
    inner: {
      title: 'Indbygget printer',
    },
    external: {
      title: 'Ekstern printer',
      width_unset: 'Papirbredde ikke angivet',
      connect_hint: 'Tilslut en printer for at bruge den',
      disconnect_confirm: 'Frakobl denne printer?',
      disconnect_confirm_description: 'Du skal konfigurere den igen.',
      disconnect_confirm_ok: 'Ja, frakobl',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Klar',
      title: 'Klar til udskrivning',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Lidt papir',
      title: 'Papiret er næsten brugt op',
      description: 'Skift rullen snart. Udskrivningen fortsætter.',
    },
    busy: {
      label: 'Optaget',
      title: 'Printeren er optaget',
      description: '{{name}} afslutter en anden opgave.',
    },
    not_configured: {
      label: 'Ikke konfigureret',
      title: 'Ikke konfigureret',
      description: '{{name}} skal konfigureres, før den kan udskrive.',
    },
    offline: {
      label: 'Offline',
      title: 'Udskriver ikke',
      description: '{{name}} er offline. Nye ordrer udskrives ikke.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} er ikke tilsluttet.',
    },
    cover_open: {
      label: 'Låg åbent',
      title: 'Låget er åbent',
      description: 'Luk printerens låg for at genoptage udskrivningen.',
    },
    paper_empty: {
      label: 'Tom for papir',
      title: 'Tom for papir',
      description: 'Skift rullen for at genoptage udskrivningen.',
    },
    wrong_paper: {
      label: 'Forkert papir',
      title: 'Forkert papir',
      description: 'Den ilagte rulle passer ikke til den indstillede papirbredde.',
    },
    cutter_error: {
      label: 'Skærefejl',
      title: 'Skærefejl',
      description: 'Tjek skæreren for fastklemt papir, og prøv igen.',
    },
    overheat: {
      label: 'For varm',
      title: 'Printeren er for varm',
      description: 'Lad {{name}} køle ned, før du udskriver igen.',
    },
    error: {
      label: 'Fejl',
      title: 'Printerfejl',
      description: '{{name}} har meldt en fejl og kræver opmærksomhed.',
    },
    connecting: {
      label: 'Tilslutter…',
      title: 'Tilslutter…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Ikke tilsluttet',
      title: 'Ikke tilsluttet',
      description: '{{name}} er ikke tilsluttet.',
    },
  },
  form: {
    auto_print: {
      label: 'Udskriv nye ordrer automatisk',
      not_ready: 'Autoudskrivning er slået til, men den eksterne printer er ikke klar. Ordrer udskrives ikke.',
    },
    print_copies: {
      label: 'Kopier pr. ordre',
      hint: 'Slå autoudskrivning til for at angive kopier',
      decrease: 'Færre kopier',
      increase: 'Flere kopier',
    },
  },
  toasts: {
    failed_to_save_changes: 'Kunne ikke gemme ændringer',
  },
  buttons: {
    test_print: 'Testudskrift',
    configure_external: 'Konfigurer',
    connect_external: 'Tilslut en printer',
    disconnect_external: 'Frakobl',
    retry_connection: 'Prøv at tilslutte igen',
    cancel: 'Annuller',
  },
};
